// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { DotIcon } from '../DotIcon'

export class DotIconSection extends Component {
  render() {
    const { iconColor, iconUrl, text, onClick, isActive } = this.props

    const listStyle = isActive
      ? {
          ...styles.listItem,
          ...styles.listItemSelected
        }
      : styles.listItem

    return (
      <li onClick={onClick} style={listStyle}>
        <DotIcon style={styles.listItemImage} url={iconUrl} color={iconColor} />
        <div style={styles.listItemText}>{text}</div>
      </li>
    )
  }
}

DotIconSection.propTypes = {
  isActive: PropTypes.bool,
  text: PropTypes.string,
  iconUrl: PropTypes.number.isRequired,
  iconColor: PropTypes.object.isRequired
}

const styles = {
  listItemImage: {
    float: 'left'
  },
  listItem: {
    cursor: 'pointer',
    listStyleType: 'none',
    height: 56,
    paddingTop: 8,
    paddingBottom: 8,
    paddingLeft: 16
  },
  listItemText: {
    paddingTop: 10,
    paddingLeft: 52
  },
  listItemSelected: {
    background: colors.lightgrey,
    fontSize: 14,
    boxSizing: 'border-box',
    borderLeft: '3px solid',
    borderColor: colors.pink,
    paddingLeft: 13
  }
}

export default DotIconSection
